import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export default function Loader() {
  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress size="25px" style={{ color: "#fff" }} />
    </Box>
  );
}
